import React, { useEffect, useState } from 'react';
import { Table, Spinner } from 'reactstrap';
import { get } from '../../../../hook/request';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function FavouriteListTable({ open }: { open?: boolean }) {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<Array<{ ID: number; userID: number; path: string; name: string }>>([]);
  const navigate = useNavigate();

  const load = async () => {
    try {
      setLoading(true);
      const res = await get<any>('/favourite/list');
      const root: any = (res as any)?.data ?? res; // axios/plain
      const list: any[] = Array.isArray(root)
        ? root
        : Array.isArray(root?.list)
        ? root.list
        : Array.isArray(root?.data?.list)
        ? root.data.list
        : [];
      setRows(
        list.map((r) => ({
          ID: Number(r.ID),
          userID: Number(r.userID ?? r.user_id ?? 0),
          path: r.path ?? '',
          name: r.name ?? '',
        }))
      );
    } catch (e: any) {
      toast.error(e?.message || 'Errore nel caricamento preferiti');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  useEffect(() => {
    if (open) load();
  }, [open]);

  if (loading)
    return (
      <div className="d-flex justify-content-center py-3">
        <Spinner size="sm" />
      </div>
    );
  if (!rows.length)
    return <div className="text-center py-3 text-muted">Nessun preferito</div>;

  return (
    <div className="table-responsive">

      <Table size="sm" borderless className="mb-0 align-middle text-center">
        <tbody>
          {rows.map((r) => (
            <tr
              key={r.ID}
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(r.path || '/')}
              className="table-hover fav-row"
            >
              <td className="py-2 align-middle text-white">
                <span style={{ color: 'black', fontWeight: 500 }}>{r.name}</span>
              </td>
              <td className="py-2 align-middle" style={{ width: 40 }}>
                <div className='d-flex align-items-center justify-content-center' style={{background:'orange',borderRadius:8, height:30, width:30}}>
                    <span style={{ color: 'white', fontSize: 18 }}>★</span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    <style>
      {`
        .fav-row:hover {
          background-color: #f4f4f4ff;
        }
      `}
    </style>
    </div>
  );
}
